module.exports = __webpack_public_path__ + "static/media/Gomex_PL_2u1_3u1_instant_kafa_tog.a4dd2016.png";